<template>
    <div class="nav-bottom-action" :class="{ 'nav-bottom-action--mobile-stack': layoutMobileStack }">
        <div v-if="liveType === 2" class="preview-sound-row" style="width: 100%;display: flex;justify-content: flex-end;padding: 5px 0;">
            <el-switch
                :value="pushStreamPreviewSoundOn"
                active-text="直播原声"
                inactive-text="静音"
                @input="onPushPreviewSoundChange"
            />
        </div>
        <div class="bottom-action">
            <el-input
                v-if="!layoutMobileStack"
                class="input"
                v-model="value"
                placeholder="说点什么..."
                @keydown.enter.native="sendBulletChat"
            ></el-input>
            <div class="bottom-right">
                <div class="actions" :class="{ 'actions--mobile-scroll': layoutMobileStack }">
                    <div :class="['action-item', item.handler]" v-for="(item, index) in actions" :key="index" @click.stop="transfer(item.handler)">
                        <div class="iconfont">{{ item.icon }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "LiveBottomAction",
    data() {
        return {
            value: "",
            actions: [
                { icon: "\uec08", handler: "liveRefresh" },
                { icon: "\ue62c", handler: "livePause" },
                { icon: "\ue625", handler: "liveStop" },
                { icon: "\ue74b", handler: "luckyBag" },
                { icon: "\ue63d", handler: "digg" },
                { icon: "\ue727", handler: "goods" },
            ],
        };
    },
    computed: {},
    components: {},
    props: {
        /** 2=电脑端推流，此时展示预览声音开关 */
        liveType: {
            type: Number,
            default: void 0,
        },
        /** 与父组件 .sync：开=预览播放麦克风原声，关=预览静音 */
        pushStreamPreviewSoundOn: {
            type: Boolean,
            default: false,
        },
        /** 手机宫格布局：隐藏弹幕输入，底部操作图标可横向滑动 */
        layoutMobileStack: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        transfer(fun) {
            this.$emit("transfer", fun);
        },
        sendBulletChat() {
            this.$emit("sendBulletChat", {
                value: this.value,
                isPerson: 1,
            });
            this.value = "";
        },
        onPushPreviewSoundChange(val) {
            this.$emit("update:pushStreamPreviewSoundOn", val);
        },
    },
    mounted() {},
};
</script>

<style scoped lang="scss">
/* 底部图标条：限制在可用宽度内，内容超出时可横向滑动（触摸友好） */
@mixin actions-horizontal-scroll {
    align-self: stretch;
    --icon-size: 30px;
    --icon-font-size: 22px;
    gap: 6px;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    justify-content: flex-start;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-x;
    overscroll-behavior-x: contain;
    scrollbar-width: thin;
    padding: 2px 4px 6px;
    box-sizing: border-box;

    .action-item {
        flex-shrink: 0;
    }
}

.nav-bottom-action--mobile-stack {
    &.nav-bottom-action {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 100%;
    }
    .bottom-action {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
}

.bottom-action {
    position: relative;
    box-sizing: border-box;
    display: flex;
    z-index: 99;
    align-items: center;
    justify-content: space-between;
    ::v-deep .input {
        width: 254px;
        height: 46px;
        input {
            height: 100%;
            padding: 0 12px;
            color: #fff;
            background-color: rgba(0, 0, 0, 0.4);
            border: none;
            border-radius: 23px;
        }
    }
    .bottom-right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
        gap: 10px;
    }
    .preview-sound-row {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
        justify-content: flex-end;
    }
    .preview-sound-label {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);
        white-space: nowrap;
    }
    ::v-deep .preview-sound-row .el-switch__label {
        color: rgba(255, 255, 255, 0.75);
        font-size: 12px;
    }
    ::v-deep .preview-sound-row .el-switch__label.is-active {
        color: #fff;
    }
    .actions {
        --icon-size: 34px;
        --icon-font-size: 24px;

        flex: 0 0 auto;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 14px;

        &.actions--mobile-scroll {
            @include actions-horizontal-scroll;
        }

        .action-item {
            width: var(--icon-size);
            height: var(--icon-size);
            // margin-left: 14px;
            color: #999;
            border-radius: 50%;
            background-color: #fff;
            user-select: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            .iconfont {
                font-size: var(--icon-font-size);
                display: inline-block;
            }

            &.livePause .iconfont {
                text-indent: 4px;
            }

            &.digg .iconfont {
                text-indent: 1px;
                margin-top: 2px;
            }
        }
        // .action-item:first-child {
        //     font-size: 20px;
        //     text-indent: 5px;
        // }
        .action-item:last-child {
            color: #4b45ff;
        }
    }
}

/* 窄视口（真机/小屏）下同样可横向滑动，无需依赖宫格布局开关 */
@media (max-width: 768px) {
    .bottom-action .bottom-right {
        align-items: stretch;
        max-width: 100%;
    }

    .bottom-action .actions {
        @include actions-horizontal-scroll;
    }
}
::v-deep .input input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #fff;
}

::v-deep .input input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #fff;
}

::v-deep .input input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #fff;
}

::v-deep .input input:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #fff;
}
</style>
